












































































































































































import { defineComponent } from '@nuxtjs/composition-api';
import AppLink from '~/components/partials/App/AppLink.vue';
import {
  WINE_TYPE_LIST,
  PRODUCT_WINE_COLOR_LABELS_FOR_LINK,
  AREA_LIST,
  VARIETY_LIST,
  SCENE_LIST,
  GOODS_ARCHIVE_LIST,
  WINE_GOODS_LINK_LIST,
  RELATED_LINK_B,
  PRODUCT_PARAM_QUERIES,
} from '~/constants';
import { url } from '~/utils';
import { BooleanLike } from '~/enums';

export default defineComponent({
  components: {
    AppLink,
  },
  props: {
    isRelatedA: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {
      url,
      BooleanLike,
      PRODUCT_WINE_COLOR_LABELS_FOR_LINK,
      WINE_TYPE_LIST,
      AREA_LIST,
      VARIETY_LIST,
      SCENE_LIST,
      GOODS_ARCHIVE_LIST,
      WINE_GOODS_LINK_LIST,
      RELATED_LINK_B,
      PRODUCT_PARAM_QUERIES,
    };
  },
});
